import styled from 'styled-components';

export const PageBody = styled.section`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
`;
